module.exports = __webpack_public_path__ + "static/media/content132.80f591e6.png";